import { ChevronRight } from "lucide-react";
import { Link } from "react-router-dom";
import { FALLBACK_HIGHLIGHTS } from "../../data/content";
import { BrushStrokes } from "../illustrations/BrushStrokes";

interface PageHeaderProps {
  title: string;
  /** Texto do item atual no breadcrumb. */
  current: string;
}

const [burger, , fries] = FALLBACK_HIGHLIGHTS;

/** Cabeçalho de páginas internas com título e breadcrumb. */
export const PageHeader = ({ title, current }: PageHeaderProps) => (
  <section className="relative isolate overflow-hidden border-b border-line bg-coal pb-16 pt-32 lg:pb-20 lg:pt-40">
    <div aria-hidden="true" className="absolute inset-0 -z-10">
      <div className="bg-dots absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,black,transparent_70%)]" />
      <div className="absolute left-1/2 top-1/2 size-[520px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-primary/10 blur-[120px]" />
      <BrushStrokes className="absolute left-1/2 top-1/2 w-[560px] -translate-x-1/2 -translate-y-[40%] opacity-[0.12]" />
      {/* Fotos decorativas nas laterais (como as ervas/pimentas da referência) */}
      <img
        src={burger.image_url}
        alt=""
        className="absolute -left-10 top-24 hidden size-40 -rotate-12 rounded-full border-4 border-coal object-cover opacity-70 shadow-card md:block lg:left-[6%]"
      />
      <img
        src={fries.image_url}
        alt=""
        className="absolute -right-8 bottom-6 hidden size-32 rotate-12 rounded-full border-4 border-coal object-cover opacity-70 shadow-card md:block lg:right-[8%]"
      />
    </div>

    <div className="mx-auto max-w-7xl px-4 text-center sm:px-6 lg:px-8">
      <h1 className="font-display text-7xl leading-none tracking-wide sm:text-8xl">{title}</h1>
      <nav aria-label="Breadcrumb" className="mt-4">
        <ol className="flex items-center justify-center gap-2 text-sm text-muted">
          <li>
            <Link to="/" className="transition-colors hover:text-primary">
              Home
            </Link>
          </li>
          <li aria-hidden="true">
            <ChevronRight className="size-4" />
          </li>
          <li aria-current="page" className="font-medium text-primary">
            {current}
          </li>
        </ol>
      </nav>
    </div>
  </section>
);
